<template>
  <!-- <ul class="author-list">
    <li v-for="(item,index) in content" :key="index">
      <div class="author-img">
        <img :src="item.friendPic">
      </div>
      <div class="cont">
        <p class="nick">{{item.friendName}}</p>
        <p class="email">{{item.des}}{{item.email}}</p>
      </div>
      <div class="care active">关注</div>
    </li>
  </ul> -->
  <div class="myCare_ul">
  	<div class="myCare_li" v-for="(item,index) in content" :key="index">
  	  <div class="author-img" style="margin-top:36px;">
  	    <img :src="item.friendPic"  style="width: 90px;height: 90px;border-radius: 50%;"/>
  	  </div>
  	  <div class="cont">
  	    <p class="nick" style="text-align: center;margin-top: 12px;">{{item.friendName}}</p>
  	    <p class="email" style="height:40px;padding: 0 12px;margin-top: 10px;overflow: hidden;">{{item.des}}{{item.email}}</p>
  	  </div>
  	  <div class="care active" @click.stop="Care(item.type,item.friendId,item.friendName)" style="color: #fff;background: #2E8043;width:100px;margin: auto;margin-top: 10px;height: 30px;line-height: 30px;">关注</div>
  	</div>
  </div>
</template>
<script>
export default {
  //   name: "App",
  data() {
    return {
      content:[]
    };
  },
  methods: {
    getCare() {
      //我的关注
      this.$http
        .get("/api/core/014-myFenSiList", {
          params: {
            token: this.$store.state.userInfo.token
          }
        })
        .then(res => {
          // console.log(res, "我的关注");
          if (res.status == 200 && res.data.code == 0) {
            this.content = res.data.rows;
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    this.getCare()
  }
};
</script>
<style scoped>
.author-list {
  width: 100%;
  margin-top: 15px;
}
.author-list li {
  height: 100px;
  padding: 15px 15px 25px;
}
.author-list li:hover {
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.15);
}
.author-list li .cont {
  width: calc(100% - 150px);
}
.myCare_ul{
	display: flex;flex-wrap: wrap;width: 100%;
}
.myCare_li{
	width: 23%;height: 260px;margin-top: 24px;border:1px solid rgba(231,231,231,1);margin-left: 2%;
}
/* .myCare_li:nth-child(4n+1){
	margin-left: 0;
} */
</style>